export const Rectangle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path d="M0 0.166626L18.6667 18.8333H0V0.166626Z" fill="#3309CD" />
  </svg>
);

export const Close = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path d="M4 4.5L20 20.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M4 20.5L20 4.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);
